import { all, call, put } from 'redux-saga/effects';

export function* setConfig() {
  console.log('saga setConfig');
}

export function* fetchData(action) {
  try {
    const data = yield call();
  } catch (error) {}
}

export default [setConfig];
